import styled from 'styled-components'

const ZasadyRachunkowosciStyle = styled.div`
  .subsection {
    width: 100%;
    display: grid;
  }

  .textarea {
    width: 100%;
    display: grid;
    min-height: 56px;
  }

  .pozostale {
    margin-top: -16px;
  }
`
export default ZasadyRachunkowosciStyle
